@if (checked && !available) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">Resource Test is not available to this login</h3>
  </div>
}

@if (available) {
  <div class="p-3 flex flex-column flex-auto">
    <h3>Resource Test</h3>
    <p class="rt-intro">
      Every resource is checked against the copies of it held inside containers and resource groups. Copies whose
      Concurrent Uses no longer matches the resource are listed below, as are containers with no resources.
    </p>
    @if (failedLoads.length > 0) {
      <div class="rt-warning">
        Could not load, so not checked: {{failedLoads.join(', ')}}
      </div>
    }
    @if (loaded) {
      <app-empty-containers [rows]="empty"></app-empty-containers>
      <app-copy-results [rows]="rows" [resourceCount]="resources.length" [holderCount]="holders.length" holderLabel="containers and resource groups"></app-copy-results>
    }
  </div>
}
